import React, { useState } from "react";
import { formDataDefault } from "Utils/Constants";
import FundingSourceList from "Components/FundingSources/FundingSourceList";
import AddAccountSuccess from "Components/AddAccountSuccess";
import { mask, endingIn } from "Utils/Utils";
import useSession from "Utils/Hooks/useSession";

import "react-datepicker/dist/react-datepicker.css";

const BankAccountFields = ({
  formData = formDataDefault,
  onFieldChange = (fieldName, fieldValue, isValid) => {
    console.warn("onFieldChange not set.");
  },
  setIsValidOverride,
  isEnrollment,
  plaidRedirect
}) => {
  const { session } = useSession();
  const [removeAccount, setRemoveAccount] = useState(false);

  const resetPlaid = (valid = true) => onFieldChange("plaidData", "", valid);
  const resetNetspend = (valid = true) =>
    onFieldChange("netspendData", "", valid);
  const resetBank = (valid = true) => {
    onFieldChange("accountNumber", "", valid);
    onFieldChange("routingNumber", "", valid);
  };
  const resetAll = () => {
    resetBank(false);
    resetNetspend(false);
    resetPlaid(false);
    setRemoveAccount(true);
  };

  // Replace form with success screen
  const showSuccessMessage = (successMsg, successTitle) => {
    const successProps = { successTitle, successMsg, removeAccount: resetAll };
    return <AddAccountSuccess {...successProps} />;
  };

  if (session.toggles.identificationInfoEnabled && plaidRedirect) {
    let idInfo = {
      country: formData.country,
      idExpiration: formData.idExpiration,
      idNumber: formData.idNumber,
      idState: formData.idState,
      idType: formData.idType,
      ssn: formData.ssn
    }
    localStorage.setItem("id-info", JSON.stringify(idInfo));
  }

  // Show success screens if any funding has been linked.
  // Also override form validation since we don't show any form fields directly.
  // This is because form validation works at the individual field level.
  if (formData.plaidData) {
    const bankName = formData.plaidData.metadata.institution.name;
    const acctMask = formData.plaidData.metadata.account.mask;
    const successMsg = `You successfully linked your ${bankName} bank account${endingIn(
      acctMask
    )}.`;
    if (setIsValidOverride) setIsValidOverride(true);
    return showSuccessMessage(successMsg);
  }

  if (formData.accountNumber && formData.routingNumber) {
    const acctMask = mask(formData.accountNumber);
    const successMsg = `You successfully added your bank account${endingIn(
      acctMask
    )}.`;
    if (setIsValidOverride) setIsValidOverride(true);
    return showSuccessMessage(successMsg);
  }

  if (formData.netspendData) {
    const successTitle = "Netspend Card Added";
    const acctMask = mask(formData.netspendData.accountNumber);
    const successMsg = `You successfully added your Netspend card${endingIn(
      acctMask
    )}.`;
    if (setIsValidOverride) setIsValidOverride();
    return showSuccessMessage(successMsg, successTitle);
  }

  setIsValidOverride(); // Clear override if bank hasn't been linked

  const setPlaidData = (plaidData) => {
    onFieldChange("plaidData", plaidData, true);
    if (plaidData) {
      resetBank();
      resetNetspend();
    }
  };

  const setBankData = (bankData) => {
    onFieldChange("accountNumber", bankData.accountNumber, true);
    onFieldChange("routingNumber", bankData.routingNumber, true);
    if (bankData) {
      resetPlaid();
      resetNetspend();
    }
  };

  const setNetspendData = (netspendData) => {
    onFieldChange("netspendData", netspendData, true);
    if (netspendData) {
      resetPlaid();
      resetBank();
    }
  };

  const fundingSourceProps = {
    bankProps: {
      onDataChanged: setBankData,
    },
    netspendProps: {
      onDataChanged: setNetspendData,
    },
  };

  if (session.toggles.plaidEnabled) {
    fundingSourceProps["plaidProps"] = {
      onDataChanged: setPlaidData,
    };
  }

  fundingSourceProps["plaidDefault"] =
    session.toggles.plaidEnabled && session.toggles.plaidDefault;

  fundingSourceProps["isEnrollment"] = isEnrollment;

  fundingSourceProps["showManualCTA"] = true;
  fundingSourceProps["showNetspendCTA"] = false;

  fundingSourceProps["plaidRedirect"] = removeAccount ? false : plaidRedirect;

  return <FundingSourceList {...fundingSourceProps} />;
};
export default BankAccountFields;
